import { http } from "../http-common";


const getActiveRoles = () => {
  return http.get(
    `/role-management/getActiveRoles`
  );
};
const getUserCreation = (page,pageSize) => {
  return http.get(`/user-management?pageNumber=${page}&pageSize=${pageSize}`);
};

const getAdministratorUserCreation = (page,pageSize) => {
  return http.get(`/user-management?isAdministrator=true&pageNumber=${page}&pageSize=${pageSize}`);
};


const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateUserManagement = (data) => {
  return http.put(`/user-management`, data);
};


const createUserManagement = (data) => {
  return http.post(
    `/user-management`, data
  );
};

const deleteManure = ({id}) => {
  return http.delete(`/greenManure/${id}`)
}

// const searchCuringUnitName = ({
//   tobaccoGroup,
//   status,
//   isNew,
//   countryCode,
//   curingUnitName,
//   page,
//   size,
// }) => {
//   const params = {
//     tobaccoGroup,
//     status,
//     isNew,
//     countryCode,
//     curingUnitName,
//     pageNumber: page,
//     pageSize: size,
//   };
//   const filteredEntries = Object.entries(params).filter(([key, value]) => value != "");
//   let newParams = Object.fromEntries(filteredEntries);
//   newParams['pageNumber'] = params.pageNumber
//   return http.get('/curingunit/search', { params: newParams });
// };



const searchManureData = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};


const searchUser = (query,page,pageSize) => {
  return http.get(`/user-management?keyword=${query}&pageNumber=${page}&pageSize=${pageSize}`);
};
const searchAdministratorUser = (query,page,pageSize) => {
  return http.get(`/user-management?isAdministrator=true&&keyword=${query}&pageNumber=${page}&pageSize=${pageSize}`);
};

//`https://dev.agri360.bat.net/a360bs`


const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword,status) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`);
};

const filterManureAutocomplete = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};
const getUserById = (userId) => {
  return http.get(`/user-management/get-user-by-id/${userId}`);
};
const UserCreationService = {
  getActiveRoles,
  getUserCreation,
  createUserManagement,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateUserManagement,
  deleteManure,
  searchUser,
  filterManure,
  filterManureAutocomplete,
  getAdministratorUserCreation,
  searchAdministratorUser,
  getUserById
};
export default UserCreationService;

